import Backdrop from "@components/Backdrop"
import { StyledButton } from "@components/buttons/Button"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body16BoldStyles, body16MainStyles } from "@constants/typography"
import useModalBackgroundClose from "@hooks/useModalBackgroundClose"
import React from "react"
import styled, { css } from "styled-components"

const openProps = css`
  opacity: 1;
  transform: translateY(0);
  transition:
    opacity ${animation.quick} ${cubicBezier},
    transform ${animation.medium} ${cubicBezier};
`

const Container = styled.div<{ $isOpen?: boolean }>`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 362px;
  padding: 68px 20px 0;
  opacity: 0;
  transform: translateY(32px);
  transition:
    opacity ${animation.quick} ${cubicBezier},
    transform ${animation.medium} ${cubicBezier};
  will-change: opacity, transform;
  background-color: ${colors.offWhite};
  cursor: default;

  ${({ $isOpen }) => ($isOpen ? openProps : "")}

  @media ${breakpoints.tablet} {
    padding: 68px 32px 0;
  }

  @media ${breakpoints.laptop} {
    display: none;
  }
`

const StyledBackdrop = styled(Backdrop)`
  z-index: 3;
`

const Row = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
`

const Discount = styled.div`
  ${body16BoldStyles}
`

const Cancel = styled.button`
  ${body16MainStyles}
  padding: 0;
  outline: none;
  border: none;
  background-color: transparent;
  color: ${colors.mediumGray};

  &:focus,
  &:active {
    outline: none;
  }
`

const Button = styled(StyledButton)`
  justify-content: center;
  margin-top: 42px;
  padding: 0;
`

interface EditDiscountProps {
  containerRef: any
  discount?: string
  isOpen: boolean
  onRemoveDiscount: () => void
  onRequestClose: () => void
}

const EditDiscount: React.FC<EditDiscountProps> = ({
  containerRef,
  discount,
  isOpen,
  onRemoveDiscount,
  onRequestClose,
}) => {
  const modalRef: any = React.useRef(null)

  useModalBackgroundClose({
    isOpen,
    modalRef,
    onRequestClose,
  })

  return (
    <StyledBackdrop $isOpen={isOpen} ref={containerRef}>
      <Container $isOpen={isOpen} ref={modalRef}>
        <Row>
          <Discount>{discount || ""}</Discount>
          <Cancel onClick={onRequestClose}>Cancel</Cancel>
        </Row>
        <Button $white onClick={onRemoveDiscount}>
          Remove
        </Button>
      </Container>
    </StyledBackdrop>
  )
}

export default EditDiscount
